import React, { Component } from 'react';
import { Modal, Input, message, Spin, Select, Radio, Switch, Table, Icon, Tooltip, Checkbox, Button } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import './index.less';
import PositiontFilter from './PositiontFilter';
import EmployeeFilter from './EmployeeFilter';


const RadioGroup = Radio.Group;

class PermissionConfig extends Component {
    state = {
        params: {
            premissionType: 'POSITION_TYPE',
            premissionLevel: 'OWNER',
        },
        visible: false,
        loading: false,
        isCheck: false,
        isAllUser: false,  // 是否按照全部人员
        data: [],
        searchParams: {},
        pagination: {
            pageSize: 10,
            current: 1,
        },
        roleCodeList: [],
        enterpriseDepartmentList: [],
        employeeEnterpriseDepartmentList: [],
        selectedRowKeys: [],
        arry: [],  // 已勾选的id
        isCheckCancelArr: [],  // 取消勾选的id
        clearArry: false,
        catalogId: '',
        crcPremissionLevels: [],
    }

    show = (record) => {
        const { params } = this.state;
        const { id } = record;
        this.setState({
            visible: true,
            params: {
                ...params,
                ...record,
            },
            catalogId: id,
            crcPremissionLevels: [],
        },() => {
            this.queryUserDepartmentList();
            this.queryEmployeeEnterpriseDepartmentList();
            this.queryRoleCodeList();
            this.loadData();
        });
    }

    queryAllUserPremission = () => {
        const { catalogId } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.deptFile.queryCrcAllUserPremission,
            data: { catalogId },
            dataType: 'json',
            doneResult: res => {
                if (res.hasAllUser) {
                    const levels = res.allUserLevels || [];
                    this.setState(prevState => ({
                        isAllUser: true,
                        params: {
                            ...prevState.params,
                            premissionType: 'ALL_EMPLOYEE_TYPE',
                        },
                        crcPremissionLevels: levels,
                    }));
                }
            },
        };
        $.sendRequest(options);
    }

    hide = () => {
        this.setState({
            params: {
                premissionType: 'POSITION_TYPE',
                premissionLevel: 'OWNER',
            },
            visible: false,
            isCheck: false,
            isAllUser: false,
            searchParams: {},
            selectedRowKeys: [],
            arry: [],
            isCheckCancelArr: [],
            clearArry: false,
            catalogId: '',
            crcPremissionLevels: [],
        });
    }

    loadData = () => {
        const { catalogId } = this.state;
        const { searchParams, pagination, params, isCheck, isCheckCancelArr } = this.state;
        const { areaParams = {} } = searchParams;
        const { current, pageSize } = pagination;
        const { premissionType, premissionLevel } = params;
        if (!premissionType) {
            return
        }
        // 全部人员不需要加载职位/人员列表
        if (premissionType === 'ALL_EMPLOYEE_TYPE') {
            this.setState({ loading: false, data: [] });
            return;
        }
        this.setState({ loading: true });

        const isCrcMode = premissionType === 'CRC_POSITION_TYPE' || premissionType === 'CRC_EMPLOYEE_TYPE';
        const isPositionMode = premissionType === 'POSITION_TYPE' || premissionType === 'CRC_POSITION_TYPE';

        let url = '';
        if (isPositionMode) {
            url = API_URL.deptFile.queryAllPosition;
        } else {
            url = API_URL.deptFile.queryUserPremission;
        }

        const requestData = {
            offset: current,
            limit: pageSize,
            premissionType,
            premissionLevel: isCrcMode ? 'UPLOAD_FILE' : premissionLevel,
            isCheck,
            catalogId,
            ...searchParams,
            ...areaParams,
            areaParams: undefined,
            hasCheckedArea: undefined,
        };
        // CRC模式传递designatedRole精确匹配，避免roleCode的LIKE匹配查到CRCC、CRCM等
        if (isCrcMode) {
            requestData.designatedRole = 'CRC';
        }

        const options = {
            method: 'POST',
            url,
            data: requestData,
            dataType: 'json',
            doneResult: res => {
                const { arry, clearArry } = this.state;
                const { positions = {}, employees = {}, positionIds = [], userIds = [], crcLevels = [] } = res;

                const idStr = isPositionMode ? 'positionId' : 'userId';
                const queryParams = isPositionMode ? positions : employees;
                const historyIds = isPositionMode ? positionIds : userIds;
                const { datas, totalCount } = queryParams;

                datas.forEach((el, index) =>{
                    el.index = (current - 1) * pageSize + index + 1;
                });

                pagination.total = totalCount;

                let newArry;
                const newSelectedRowKeys = [];

                if (clearArry) {
                    newArry = [
                        ...arry.filter(el => datas.some(innerItem => innerItem[idStr] == el)),
                        ...historyIds,
                    ];
                    this.setState({ clearArry: false });
                } else {
                    newArry = [
                        ...arry,
                        ...historyIds.filter(id => !isCheckCancelArr.includes(id)),
                    ];
                }

                // ========== 去重处理 ==========
                const uniqueSet = new Set(newArry.map(id => String(id)));
                newArry = Array.from(uniqueSet).map(id => {
                    const numId = Number(id);
                    return isNaN(numId) ? id : numId;
                });

                newArry.forEach(item => {
                    const selectData = datas.find(innerItem => innerItem[idStr] == item);
                    if (selectData) {
                        newSelectedRowKeys.push(selectData.index);
                    }
                });

                // CRC模式：更新已配置的权限级别
                const stateUpdate = {
                    loading: false,
                    pagination,
                    data: datas,
                    arry: newArry,
                    selectedRowKeys: newSelectedRowKeys,
                };
                if (isCrcMode) {
                    stateUpdate.crcPremissionLevels = crcLevels.length > 0 ? crcLevels : [];
                } else {
                    stateUpdate.crcPremissionLevels = [];
                }

                this.setState(stateUpdate);
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    queryRoleCodeList = () => {
        const options = {
            method: 'POST',
            url: API_URL.role.list,
            dataType: 'json',
            doneResult: res => {
                const { datas } = res;
                const { roleCodeList } = this.state;
                (datas || []).map(el => {
                    roleCodeList.push({
                        value: el.roleCode,
                        label: el.roleCode,
                    })
                })
                this.setState({ roleCodeList });
            },
        };
        $.sendRequest(options);
    }

    queryUserDepartmentList = () => {
        const options = {
            method: 'POST',
            url: API_URL.user.queryUserDepartmentSelect,
            data: { level: 4 },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                const { enterpriseDepartmentList } = this.state;
                (data || []).map(el => {
                    enterpriseDepartmentList.push({
                        value: el.enterpriseDepartmentId,
                        label: el.enterpriseDepartmentName,
                    })
                })
                this.setState({ enterpriseDepartmentList });
            },
        };
        $.sendRequest(options);
    }

    queryEmployeeEnterpriseDepartmentList = () => {
        const options = {
            method: 'POST',
            url: API_URL.user.queryUserDepartmentSelect,
            data: { level: 5 },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                const { employeeEnterpriseDepartmentList } = this.state;
                (data || []).map(el => {
                    employeeEnterpriseDepartmentList.push({
                        value: el.enterpriseDepartmentId,
                        label: el.enterpriseDepartmentName,
                    })
                })
                this.setState({ employeeEnterpriseDepartmentList });
            }
        };
        $.sendRequest(options);
    }


    submit = () => {
        const { params, arry, catalogId, crcPremissionLevels, isAllUser } = this.state;
        const {
            premissionType,
            premissionLevel,
        } = params;

        const isCrcMode = premissionType === 'CRC_POSITION_TYPE' || premissionType === 'CRC_EMPLOYEE_TYPE';

        let url = '';
        const sendParams = {};

        if (!isAllUser && arry.length === 0) {
            message.warning('请勾选需要配置权限的角色');
            return
        }

        if (isAllUser) {
            url = API_URL.deptFile.addCrcAllUserPremission;
            sendParams.premissionLevels = crcPremissionLevels.join(',');
        } else if (isCrcMode) {
            if (crcPremissionLevels.length === 0) {
                message.warning('请选择上传权限和/或下载权限');
                return
            }
            if (premissionType === 'CRC_POSITION_TYPE') {
                url = API_URL.deptFile.addCrcPositionPremission;
                sendParams.positionIds = arry.join(',');
            } else {
                url = API_URL.deptFile.addCrcUserPremission;
                sendParams.userIds = arry.join(',');
            }
            sendParams.premissionLevels = crcPremissionLevels.join(',');
        } else {
            if (!premissionLevel) {
                message.warning('请选择owner权限或普通权限');
                return;
            }
            if (premissionType === 'POSITION_TYPE') {
                url = API_URL.deptFile.addPositionPremission;
                sendParams.positionIds = arry.join(',');
            } else {
                url = API_URL.deptFile.addUserPremission;
                sendParams.userIds = arry.join(',');
            }
        }

        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url,
            data: {
                premissionType,
                catalogId,
                ...(isCrcMode ? {} : { premissionLevel }),
                ...sendParams,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                }, () => {
                    this.hide();
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    // 设置/取消全体CRC
    handleAllCrc = (isSelectAll) => {
        const { params, catalogId, crcPremissionLevels } = this.state;
        const { premissionType } = params;

        if (crcPremissionLevels.length === 0) {
            message.warning('请先选择上传权限和/或下载权限');
            return;
        }

        let url = '';
        const sendParams = {};
        if (premissionType === 'CRC_POSITION_TYPE') {
            url = API_URL.deptFile.addCrcPositionPremission;
        } else {
            url = API_URL.deptFile.addCrcUserPremission;
        }
        sendParams.premissionLevels = crcPremissionLevels.join(',');
        sendParams.allPosition = isSelectAll ? 'selectAll' : 'cancelAll';

        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url,
            data: {
                premissionType,
                catalogId,
                ...sendParams,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.hide();
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleRadioChange = (value, key) => {
        const { params } = this.state;
        if (key === 'premissionType') {
            const isCrcValue = value === 'CRC_POSITION_TYPE' || value === 'CRC_EMPLOYEE_TYPE';
            const isCrcOld = params.premissionType === 'CRC_POSITION_TYPE' || params.premissionType === 'CRC_EMPLOYEE_TYPE';
            params[key] = value;
            // 切换CRC/非CRC模式时，重置premissionLevel为默认值
            if (isCrcValue !== isCrcOld) {
                params.premissionLevel = isCrcValue ? 'UPLOAD_FILE' : 'OWNER';
            }
            const isAllUser = value === 'ALL_EMPLOYEE_TYPE';
            const stateUpdate = {
                params,
                searchParams: {},
                clearArry: true,
                isAllUser,
            };
            this.setState(stateUpdate, () => {
                this.loadData();
                if (isAllUser) {
                    this.queryAllUserPremission();
                }
            });
        } else {
            params[key] = value;
            this.setState({
                params,
                searchParams: {},
                clearArry: true,
            }, () => {
                this.loadData();
            });
        }
    }

    handleSwitchChange = (checked) => {
        this.setState({ isCheck: checked }, () => {
            this.loadData();
        });
    }

    handleCrcLevelChange = (checkedValues) => {
        this.setState({ crcPremissionLevels: checkedValues });
    }

    getColumns = () => {
        const { params: { premissionType } } = this.state;
        const isPositionMode = premissionType === 'POSITION_TYPE' || premissionType === 'CRC_POSITION_TYPE';
        const columns = isPositionMode ? [{
            title: '部门',
            dataIndex: 'enterpriseDepartmentName',
            key: 'enterpriseDepartmentName',
            width: 160,
        }, {
            title: '下级组织',
            dataIndex: 'xjDepName',
            key: 'xjDepName',
            width: 160,
            render: text => text || '-',
        }, {
            title: '下下级组织',
            dataIndex: 'xxjDepName',
            key: 'xxjDepName',
            width: 160,
            render: text => text || '-',
        }, {
            title: '职位级别',
            dataIndex: 'positionName',
            key: 'positionName',
            width: 160,
        }, {
            title: '对应角色',
            dataIndex: 'roleCode',
            key: 'roleCode',
            width: 140,
        }] : [{
            title: '工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            width: 100,
        }, {
            title: '姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 80,
        }, {
            title: '部门',
            dataIndex: 'enterpriseDepartmentName',
            key: 'enterpriseDepartmentName',
            width: 110,
        }, {
            title: '下级组织',
            dataIndex: 'xjDepName',
            key: 'xjDepName',
            width: 100,
            render: text => text || '-',
        }, {
            title: '职位级别',
            dataIndex: 'positionName',
            key: 'positionName',
            width: 100,
        }, {
            title: '职位角色',
            dataIndex: 'roleCode',
            key: 'roleCode',
            width: 80,
        }, {
            title: '主管领导',
            dataIndex: 'leaderNameCode',
            key: 'leaderNameCode',
            width: 100,
        }, {
            title: '区域/城市',
            dataIndex: 'regionName',
            key: 'regionName',
            width: 90,
        }];
        return columns;
    }

    handleTableChange = (pagination) => {
        this.setState({
            pagination,
            clearArry: false,
        }, () => {
            this.loadData();
        });
    }

    search = () => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({ 
            pagination,
        }, () => {
            this.loadData();
        });
    }

    onSelectChange = (record, selected) => {
        const { selectedRowKeys, arry, params, isCheck, isCheckCancelArr } = this.state;
        const { premissionType } = params;

        const isPositionMode = premissionType === 'POSITION_TYPE' || premissionType === 'CRC_POSITION_TYPE';
        const idStr = isPositionMode ? 'positionId' : 'userId';

        if (selected) {
            const isExist = selectedRowKeys.some(item => item == record.index);
            !isExist && selectedRowKeys.push(record.index);
            const isIdExist = arry.some(item => item == record[idStr]);
            if (!isIdExist) {
                arry.push(record[idStr]);
                isCheck && isCheckCancelArr.splice(isCheckCancelArr.indexOf(record[idStr]), 1);
            }
        } else {
            let idx;
            selectedRowKeys.forEach((item, index) => {
                if (record.index == item) {
                    idx = index;
                }
            });
            (idx || (!idx && idx === 0)) && selectedRowKeys.splice(idx, 1);

            // 删除已存在的id
            let idIdx;
            arry.forEach((item, index) => {
                if (record[idStr] == item) {
                    idIdx = index;
                }
            });
            if (idIdx || (!idIdx && idIdx === 0)) {
                isCheck && isCheckCancelArr.push(record[idStr]);
                arry.splice(idIdx, 1);
            }
        }
        this.setState({
            arry,
            isCheckCancelArr,
            selectedRowKeys,
        });
    }

    onSelectAllChange = (selected, selectedRows, changeRows) => {
        const { arry, selectedRowKeys, params } = this.state;
        const { premissionType } = params;

        const isPositionMode = premissionType === 'POSITION_TYPE' || premissionType === 'CRC_POSITION_TYPE';
        const idStr = isPositionMode ? 'positionId' : 'userId';
        if (selected) {
            changeRows.forEach(item => {
                let idx;
                selectedRowKeys.forEach((selectItem, index) => {
                    if (selectItem == item.index) {
                        idx = index;
                    }
                });
                !(idx || (!idx && idx === 0)) && selectedRowKeys.push(item.index);

                let idIdx;
                arry.forEach((arryItem, index) => {
                    if (arryItem == item[idStr]) {
                        idIdx = index;
                    }
                });
                if (!(idIdx || (!idIdx && idIdx === 0))) {
                    arry.push(item[idStr]);
                }
            });
        } else {
            changeRows.forEach(item => {
                let idx;
                selectedRowKeys.forEach((selectItem, index) => {
                    if (selectItem == item.index) {
                        idx = index;
                    }
                });
                (idx || (!idx && idx === 0)) && selectedRowKeys.splice(idx, 1);

                let idIdx;
                arry.forEach((arryItem, index) => {
                    if (arryItem == item[idStr]) {
                        idIdx = index;
                    }
                });
                if (idIdx || (!idIdx && idIdx === 0)) {
                    arry.splice(idIdx, 1);
                }
            });
        }
        this.setState({
            arry,
            selectedRowKeys,
        });
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    handlePremissionLevelClick = (value) => {
        const { premissionLevel } = this.state.params;
        if (premissionLevel === value) {
            this.handleRadioChange(null, 'premissionLevel');
        } else {
            this.handleRadioChange(value, 'premissionLevel');
        }
    }

    getContent = () => {
        const {
            params,
            searchParams,
            isCheck,
            isAllUser,
            data,
            pagination,
            enterpriseDepartmentList,
            employeeEnterpriseDepartmentList,
            roleCodeList,
            selectedRowKeys,
            arry,
            loading,
            crcPremissionLevels,
        } = this.state;
        const { premissionType, premissionLevel, catalogName } = params;
        const isCrcMode = premissionType === 'CRC_POSITION_TYPE' || premissionType === 'CRC_EMPLOYEE_TYPE';
        const isPositionMode = premissionType === 'POSITION_TYPE' || premissionType === 'CRC_POSITION_TYPE';
        const idStr = isPositionMode ? 'positionId' : 'userId';
        const rowSelection = {
            selectedRowKeys: arry,
            onSelect: this.onSelectChange,
            onSelectAll: this.onSelectAllChange,
            getCheckboxProps: record => ({
                // disabled: !record.batchDownloadFlag,
            }),
        };
        return (
            <div className='permission_list'>
                <div className='title'>目录名称：{catalogName}</div>
                <div className='item'>第一步：选择按照职位级别/人员去配置权限</div>
                <div className='item'>
                    <RadioGroup
                        value={premissionType}
                        onChange={e => this.handleRadioChange(e.target.value, 'premissionType')}
                    >
                        <Radio value={'POSITION_TYPE'}>{'按照职位级别'}</Radio>
                        <Radio value={'EMPLOYEE_TYPE'}>{'按照人员'}</Radio>
                        <Radio value={'ALL_EMPLOYEE_TYPE'}>{'按照全部人员'}</Radio>
                        <Radio value={'CRC_POSITION_TYPE'}>{'CRC按职位'}</Radio>
                        <Radio value={'CRC_EMPLOYEE_TYPE'}>{'CRC按人员'}</Radio>
                    </RadioGroup>
                </div>
                <div className='item'>
                    {isCrcMode ? '第二步：选择配置上传权限/下载权限' : '第二步：选择配置owner权限/普通权限'}
                    <span style={{ marginLeft: 25 }}>
                        <Tooltip
                        overlayStyle={{ width: 280 }}
                        placement="top"
                        title={
                            isCrcMode ? (
                                <span>针对CRC人员的下载文件以及上传文件的权限配置</span>
                            ) : (
                                <span>
                                owner 权限：代表拥有该目录及所有子级目录的权限管理以及新增、修改、删除权限<br/>
                                        代表拥有所有目录下文件的批量下载、上传、预览、下载、删除权限<br/>
                                普通权限：代表无任何关于目录的权限<br/>
                                        如果职位角色是 CRC ，那么仅拥有文件的预览权限<br/>
                                        如果职位角色非 CRC，那么拥有文件的批量下载预览、下载权限<br/>
                                </span>
                            )
                        }
                        >
                            <a style={{ display: 'flex', alignItems: 'center' }}>
                                权限规则说明
                                <Icon type="info-circle-o" style={{ marginLeft: 6 }} />
                            </a>
                        </Tooltip>
                    </span>
                </div>
                <div className='item'>
                    {premissionType === 'ALL_EMPLOYEE_TYPE' ? (
                        <Checkbox.Group
                            value={crcPremissionLevels}
                            onChange={this.handleCrcLevelChange}
                        >
                            <Checkbox value={'OWNER'}>{'owner权限'}</Checkbox>
                            <Checkbox value={'COMMON'}>{'普通权限'}</Checkbox>
                        </Checkbox.Group>
                    ) : isCrcMode ? (
                        <Checkbox.Group
                            value={crcPremissionLevels}
                            onChange={this.handleCrcLevelChange}
                        >
                            <Checkbox value={'UPLOAD_FILE'}>{'上传'}</Checkbox>
                            <Checkbox value={'DOWNLOAD_FILE'}>{'下载'}</Checkbox>
                        </Checkbox.Group>
                    ) : (
                        <div>
                            <Radio
                                checked={premissionLevel === 'OWNER'}
                                onChange={() => this.handlePremissionLevelClick('OWNER')}
                            >{'owner权限'}</Radio>
                            <Radio
                                checked={premissionLevel === 'COMMON'}
                                onChange={() => this.handlePremissionLevelClick('COMMON')}
                                style={{ marginLeft: 24 }}
                            >{'普通权限'}</Radio>
                        </div>
                    )}
                </div>
                {!isAllUser && (
                    <div className='item'>
                        {isPositionMode ?
                            <PositiontFilter
                                search={this.search}
                                enterpriseDepartmentList={enterpriseDepartmentList}
                                params={searchParams}
                                onChange={this.handleFilterChange}
                            />
                            :
                            <EmployeeFilter
                                search={this.search}
                                roleCodeList={isCrcMode ? [] : (roleCodeList || [])}
                                enterpriseDepartmentList={employeeEnterpriseDepartmentList}
                                searchParams={searchParams}
                                onChange={this.handleFilterChange}
                                hideRoleCode={isCrcMode}
                            />
                        }
                    </div>
                )}
                {!isAllUser && (
                    <div className='item'>
                        是否仅查看已勾选
                        <Switch
                            size="small"
                            checked={isCheck}
                            onChange={this.handleSwitchChange}
                            style={{marginLeft: 5}}
                        />
                        {isCrcMode && (
                            <span style={{ marginLeft: 15 }}>
                                <Button type="primary" size="small" style={{ marginRight: 8 }} onClick={() => this.handleAllCrc(true)}>设置全员CRC</Button>
                                <Button type="primary" size="small" onClick={() => this.handleAllCrc(false)}>取消设置全员CRC</Button>
                            </span>
                        )}
                    </div>
                )}
                {!isAllUser && (
                    <div className='item'>
                        <Table
                            bordered
                            rowSelection={rowSelection}
                            rowKey={record => record[idStr]}
                            pagination={pagination}
                            dataSource={data}
                            scroll={{ x: 500 }}
                            loading={loading}
                            columns={this.getColumns()}
                            onChange={this.handleTableChange}
                        />
                    </div>
                )}
            </div>
        )
    }

    render() {
        const { visible, loading } = this.state;
        return (
            <Modal
                title={'权限管理'}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="900px"
                bodyStyle={{ minHeight: 400, maxHeight: 600 }}
            >
                <Spin spinning={loading}>
                    {this.getContent()}
                </Spin>
            </Modal>
        )
    }
}

export default PermissionConfig;


// WEBPACK FOOTER //
// ./src/components/documentManagement/departmentalDocuments/PermissionConfig.js